import { http } from '@/plugins/axios';
import { IPremiseVehicleNumberArguments } from '@/@types/api/premiseVehicles';

const endPoint = '/PremiseVehicles';

const getPremiseVehicles = (premiseID: number) => {
  return http.get(`${endPoint}/Get`, { params: { premiseID } });
};

const setPremiseVehicles = (payload: IPremiseVehicleNumberArguments) => {
  return http.post(`${endPoint}/Set`, payload);
};

export default {
  getPremiseVehicles,
  setPremiseVehicles,
};
